import ThirdPartyPropertyData from './ThirdPartyPropertyData';
import ThirdPartyPropertyDataCommercial from './ThirdPartyPropertyDataCommercial';
import ThirdPartyPropertyDataPersonal from './ThirdPartyPropertyDataPersonal';

export {
	ThirdPartyPropertyData,
	ThirdPartyPropertyDataCommercial,
	ThirdPartyPropertyDataPersonal,
};